import ExistClientMapper from '@/modules/common/hiring/mappers/MID/ExistClientMapper'
import GetRecoveryMapper from './MID/GetRecoveryMapper'
import SaveDocumentMapper from '@/modules/common/hiring/mappers/MID/SaveDocumentMapper'
import SavePolicyHolderMapper from './MID/SavePolicyHolderMapper'
import SaveInsuredMapper from './MID/SaveInsuredMapper'
import GetPricingMapper from './MID/GetPricingMapper'
import SaveQuotationMapper from '@/modules/common/common/mappers/MID/SaveQuotationMapper'

export default {
  GetRecoveryMapper,
  SaveDocumentMapper,
  ExistClientMapper,
  SavePolicyHolderMapper,
  SaveInsuredMapper,
  GetPricingMapper,
  SaveQuotationMapper
}
